"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconReplyAll = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M7.8333 8.6667 7.8333 6.1667 2 12 7.8333 17.8333 7.8333 15.3333 4.5 12 7.8333 8.6667ZM12.8333 9.5 12.8333 6.1667 7 12 12.8333 17.8333 12.8333 14.4167C17 14.4167 19.9167 15.75 22 18.6667 21.1667 14.5 18.6667 10.3333 12.8333 9.5Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconReplyAll')(IconReplyAll);